/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

import {Injectable} from '@angular/core';
import {FilesService} from 'app/services/files.service'
import {StoryboardService} from 'app/services/storyboard.service'
import {TopicService} from 'app/services/topic.service'
import {IAssetsService} from 'app/models/asset.service.interface'
import {Source} from 'app/models/source.enum'
@Injectable({
  providedIn: 'root'
})
export class AssetsFactory {

    constructor(private fileService: FilesService, private storyBoardService: StoryboardService, private topicService: TopicService) {

    }
    public getInstance(assetType: string): IAssetsService {
        switch (assetType) {
            case Source.Video:
            case Source.Image:
            case Source.PDF:
                return this.fileService
            case Source.Storyboard:
                return this.storyBoardService;
            case Source.Topic:
                return this.topicService
            default:
                return this.fileService;
        }
    }
}